import { useEffect, useState } from "react";

export default function DownloadAndroid() {
  const [isAndroid, setIsAndroid] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL || "https://igapp-production.up.railway.app";
  const apkUrl = `${apiUrl}/public/downloads/igrowth.apk`;

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    setIsAndroid(/android/i.test(ua));
  }, []);

  const handleDownload = () => {
    window.location.href = apkUrl;
  };

  return (
    <div className="flex flex-col items-center min-h-screen p-4 bg-white">

      {/* EU Logos - Top Center */}
      <div className="flex items-center gap-4 justify-between mx-auto min-w-[410px] mb-8">
        <img src="/assets/cofinantare.png" alt="Cofinanțare Uniunea Europeană" className="h-12 mt-8 ml-8" />
        <img src="/assets/gov_ro.svg" alt="Guvernul României" className="h-12 mt-8 mr-8" />
      </div>

      {/* Two Column Layout */}
      <div className="grid flex-1 w-full max-w-4xl gap-6 md:grid-cols-2">

        {/* Left Column - App Info & Download */}
        <div className="flex flex-col justify-center p-8 text-center border shadow-2xl bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 backdrop-blur-lg rounded-3xl border-white/20">
          {/* App Icon */}
          <div className="mb-6">
            <img
              src="/assets/igrowth_192.png"
              alt="iGROWth"
              className="w-24 h-24 mx-auto shadow-lg rounded-2xl"
            />
          </div>

          {/* App Info */}
          <h1 className="mb-1 text-3xl font-bold text-white">iGROWth</h1>
          <p className="mb-2 text-lg text-indigo-200">
            Sports Club Management
          </p>
          <p className="mb-8 text-sm text-indigo-300/60">
            Versiune 1.0.5
          </p>

          {/* Download Button */}
          <button
            onClick={handleDownload}
            className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-semibold py-4 px-6 rounded-2xl transition-all duration-200 transform hover:scale-[1.02] active:scale-95 shadow-lg shadow-emerald-500/25 flex items-center justify-center gap-3"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.523 2.226a.75.75 0 00-1.046 0L14.07 4.633A8.96 8.96 0 0012 4.25a8.96 8.96 0 00-2.07.383L7.523 2.226a.75.75 0 10-1.046 1.048l2.027 2.027A8.963 8.963 0 003.25 13v.75h17.5V13a8.963 8.963 0 00-5.254-7.699l2.027-2.027a.75.75 0 000-1.048zM9.5 11a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zM3.25 15.25v4A3.75 3.75 0 007 23h10a3.75 3.75 0 003.75-3.75v-4H3.25z" />
            </svg>
            Descarcă pentru Android
          </button>

          {/* Features */}
          <div className="grid grid-cols-3 gap-3 mt-6">
            <div className="p-3 border bg-white/5 rounded-xl border-white/10">
              <svg className="w-5 h-5 text-emerald-400 mx-auto mb-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <p className="text-xs text-indigo-200">Securizat</p>
            </div>
            <div className="p-3 border bg-white/5 rounded-xl border-white/10">
              <svg className="w-5 h-5 text-emerald-400 mx-auto mb-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              <p className="text-xs text-indigo-200">Rapid</p>
            </div>
            <div className="p-3 border bg-white/5 rounded-xl border-white/10">
              <svg className="w-5 h-5 text-emerald-400 mx-auto mb-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              <p className="text-xs text-indigo-200">Notificări</p>
            </div>
          </div>

          {!isAndroid && (
            <div className="p-4 mt-4 border bg-amber-500/15 border-amber-500/25 rounded-2xl">
              <p className="text-sm text-amber-200">
                Această aplicație este disponibilă doar pentru dispozitive Android.
                Deschide acest link de pe telefonul tău Android.
              </p>
            </div>
          )}
        </div>

        {/* Right Column - Instructions */}
        <div className="flex flex-col justify-center p-8 border shadow-2xl bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 backdrop-blur-lg rounded-3xl border-white/20">
          <h3 className="mb-6 text-xl font-bold text-white">Instrucțiuni de instalare</h3>
          <ol className="space-y-4 text-sm text-indigo-200">
            <li className="flex items-start gap-4">
              <span className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-bold rounded-full bg-emerald-500/20 text-emerald-400">1</span>
              <div>
                <p className="font-medium text-white">Descarcă aplicația</p>
                <p className="mt-1 text-xs text-indigo-300/70">Apasă butonul "Descarcă pentru Android" din stânga</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-bold rounded-full bg-emerald-500/20 text-emerald-400">2</span>
              <div>
                <p className="font-medium text-white">Deschide fișierul</p>
                <p className="mt-1 text-xs text-indigo-300/70">Găsește fișierul descărcat în notificări sau în folderul Downloads</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-bold rounded-full bg-emerald-500/20 text-emerald-400">3</span>
              <div>
                <p className="font-medium text-white">Permite instalarea</p>
                <p className="mt-1 text-xs text-indigo-300/70">Activează "Instalare din surse necunoscute" dacă ți se cere</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm font-bold rounded-full bg-emerald-500/20 text-emerald-400">4</span>
              <div>
                <p className="font-medium text-white">Instalează și deschide</p>
                <p className="mt-1 text-xs text-indigo-300/70">Apasă "Instalare", apoi deschide aplicația și autentifică-te</p>
              </div>
            </li>
          </ol>

          {/* QR hint */}
          <div className="p-4 mt-6 border bg-white/5 rounded-xl border-white/10">
            <div className="flex items-center gap-3">
              <svg className="flex-shrink-0 w-6 h-6 text-indigo-300/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-xs text-indigo-300/60">
                Ești pe calculator? Trimite acest link pe telefonul tău Android pentru a descărca aplicația.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* EU Disclaimer - Bottom Center */}
      <div className="w-full max-w-4xl mt-8 mb-4">
        <div className="p-6 text-xs font-semibold text-center text-slate-900">
          <p>
            Această platformă web și aplicație mobilă au fost realizate cu sprijinul financiar al Uniunii Europene prin Programul Educației și Ocupare 2021-2027, cofinanțat din FSE+.<br/>
            Conținutul acestui material nu reprezintă în mod obligatoriu poziția oficială a Uniunii Europene sau a Guvernului României.<br/>
            Pentru informații detaliate despre celelalte programe finanțate de Uniunea Europeană, vă rugăm să vizitați{" "}
            <a href="https://www.fonduri-ue.ro" target="_blank" rel="noopener noreferrer" className="underline">
              www.fonduri-ue.ro
            </a>
          </p>
        </div>
        <p className="text-xs text-center text-slate-900">
          © {new Date().getFullYear()} iGROWth. Toate drepturile rezervate.
        </p>
      </div>
    </div>
  );
}
